import { jsx as i } from "react/jsx-runtime";
import { forwardRef as n } from "react";
import u from "@mui/material/MenuItem";
import d from "styled-components";
const l = {
  root: "menuItemRoot",
  focusVisible: "menuItemFocusVisible",
  dense: "menuItemDense",
  disabled: "menuItemDisabled",
  divider: "menuItemDivider",
  gutters: "menuItemGutters",
  selected: "menuItemSelected"
}, s = d(u).withConfig({
  displayName: "StyledMenuItem"
})([
  "& + &{margin-top:1px;}&&.menuItemRoot{min-height:34px;color:",
  ";outline:none;border-radius:4px;line-height:1.2em;}&&.menuItemRoot.menuItemDense{min-height:30px;}&&.menuItemGutters{padding-left:8px;padding-right:8px;}&&.menuItemDivider{border:none;}&&.menuItemDivider:after{height:1px;position:absolute;right:0px;left:0px;bottom:-1px;background-color:",
  ";content:'';z-index:1;}&&.menuItemRoot:hover:not(.menuItemDisabled),&&.menuItemRoot.Mui-focusVisible:not(.menuItemDisabled){color:",
  ";background-color:",
  ";}&&&.menuItemSelected:not(.menuItemDisabled){color:",
  ";background-color:",
  ";}&&.menuItemDisabled{opacity:1;color:",
  ";}&&.menuItemSelected.menuItemDisabled{background-color:",
  ";color:",
  ";}"
], ({ theme: e }) => e.text.primary, ({ theme: e }) => e.primaryBorder, ({ theme: e }) => e.colors.white, ({ theme: e }) => e.primaryHover, ({ theme: e }) => e.colors.white, ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.secondaryDisabled, ({ theme: e }) => e.primaryDisabled, ({ theme: e }) => e.secondaryDisabled), a = /* @__PURE__ */ n(({ children: e, tabIndex: t = 0, classes: o, ...m }, r) => /* @__PURE__ */ i(s, {
  ...m,
  tabIndex: t,
  ref: r,
  classes: {
    ...l,
    ...o
  },
  children: e
}));
a.displayName = "MenuItem";
export {
  a as default
};
